import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { IContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder/pageBuilder.domains'

import { ProductSectionType } from '../../types/productPage.types'
import {
  DESKTOP_DISCLAIMER,
  DESKTOP_FAQ,
  DESKTOP_FBT,
  DESKTOP_INFLUENCER,
  DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
  DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
  DESKTOP_PRODUCT_REVIEWS,
  DESKTOP_SIMILAR_PRODUCTS,
  DESKTOP_TRANSPARENT_PRICING,
  DESKTOP_YOU_MAY_ALSO_LIKE,
} from '../common'
import {
  MOBILE_BRAND_COMPARISON,
  MOBILE_DISCLAIMER,
  MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
  MOBILE_INFLUENCER,
  MOBILE_INFORMATION_BOXES,
  MOBILE_PAIR_WITH,
  MOBILE_PRODUCT_DETAILS_AND_CARE,
  MOBILE_PRODUCT_IMAGES,
  MOBILE_PRODUCT_PURCHASE,
  MOBILE_PRODUCT_REVIEWS,
  MOBILE_REVIEW_HIGHLIGHTS,
  MOBILE_SIMILAR_PRODUCTS,
  MOBILE_TRANSPARENT_PRICING,
  MOBILE_YOU_MAY_ALSO_LIKE,
} from '../common/mobile'

export const longFormDesktopConfig: IContainerConfig = {
  id: 'DESKTOP_LONG_FORM_DESKTOP_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
    DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
    DESKTOP_SIMILAR_PRODUCTS,
    DESKTOP_PRODUCT_REVIEWS,
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_2,
      },
    },
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE_SCALE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_4,
      },
    },
    {
      id: 'DESKTOP_STACKED_NEW_LONG_FORM',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.STACKED_NEW_LONG_FORM,
      },
    },
    {
      id: 'DESKTOP_ROW_OF_IMAGE_TEXT_BLOCKS',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.ROW_OF_IMAGE_TEXT_BLOCKS,
      },
    },
    {
      id: 'DESKTOP_TEXT_BLOCK_WITH_ICON_ROW',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.TEXT_BLOCK_WITH_ICON_ROW,
      },
    },
    {
      id: 'DESKTOP_PRODUCT_COMPARISON',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_7,
      },
    },
    {
      id: 'DESKTOP_FULL_BLEED_MEDIA',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FULL_BLEED_MEDIA,
      },
    },
    DESKTOP_FBT,
    DESKTOP_TRANSPARENT_PRICING,
    DESKTOP_INFLUENCER,
    DESKTOP_FAQ,
    DESKTOP_YOU_MAY_ALSO_LIKE,
    DESKTOP_DISCLAIMER,
  ],
}

export const longFormMobileConfig: IContainerConfig = {
  id: 'MOBILE_LONG_FORM_DESKTOP_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    MOBILE_PRODUCT_IMAGES,
    MOBILE_PRODUCT_PURCHASE,
    MOBILE_REVIEW_HIGHLIGHTS,
    MOBILE_PRODUCT_DETAILS_AND_CARE,
    MOBILE_BRAND_COMPARISON,
    MOBILE_PAIR_WITH,
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_2,
      },
    },
    {
      id: 'MOBILE_PRODUCT_SHOWCASE_SCALE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_4,
      },
    },
    {
      id: 'MOBILE_STACKED_NEW_LONG_FORM',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.STACKED_NEW_LONG_FORM,
      },
    },
    {
      id: 'MOBILE_ROW_OF_IMAGE_TEXT_BLOCKS',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.ROW_OF_IMAGE_TEXT_BLOCKS,
      },
    },
    {
      id: 'MOBILE_TEXT_BLOCK_WITH_ICON_ROW',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.TEXT_BLOCK_WITH_ICON_ROW,
      },
    },
    {
      id: 'MOBILE_PRODUCT_COMPARISON',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_7,
      },
    },
    {
      id: 'MOBILE_FULL_BLEED_MEDIA',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FULL_BLEED_MEDIA,
      },
    },
    MOBILE_SIMILAR_PRODUCTS,
    MOBILE_TRANSPARENT_PRICING,
    MOBILE_INFLUENCER,
    MOBILE_INFORMATION_BOXES,
    MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
    MOBILE_PRODUCT_REVIEWS,
    MOBILE_YOU_MAY_ALSO_LIKE,
    MOBILE_DISCLAIMER,
  ],
}
